import React from 'react';
import { useCurrentRefinements, UseCurrentRefinementsProps } from 'react-instantsearch-hooks-web';
import { StateName } from 'components/helpers/NmdpSite/TCDirectorySearch/_states';

const isModifierClick = (event: React.MouseEvent) => {
  const isMiddleClick = event.button === 1;

  return Boolean(isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
};

const CustomCurrentRefinements = (props: UseCurrentRefinementsProps) => {
  const { items, refine } = useCurrentRefinements(props);
  items.filter((item) => item.attribute === 'state');

  return (
    <div className="ais-CurrentRefinements">
      <ul className="ais-CurrentRefinements-list">
        {items.map((item) => (
          <li key={[item.indexName, item.label].join('/')} className="ais-CurrentRefinements-item">
            {item.refinements.map((refinement) => (
              <span className="ais-CurrentRefinements-category" key={refinement.value}>
                <span className="ais-CurrentRefinements-categoryLabel">
                  {StateName(refinement.label)}
                </span>
                <button
                  type="button"
                  className="ais-CurrentRefinements-delete"
                  onClick={(event) => {
                    if (isModifierClick(event)) {
                      return;
                    }

                    refine(refinement);
                  }}
                >
                  ✕
                </button>
              </span>
            ))}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomCurrentRefinements;
